import { render, staticRenderFns } from "./CardTrustScore.vue?vue&type=template&id=ef87dfda&"
import script from "./CardTrustScore.vue?vue&type=script&lang=js&"
export * from "./CardTrustScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports